import { type CommandHandler } from "../..";
import { type CustomSetting, settings } from "..";

import CommandLayout from "./CommandLayout.svelte";

// {
//     commands: Record<string, Command>,
//         rebindHotkey: (id: any, hotkey: string) => void,
// }
export function createCommandPage(handler: CommandHandler) {
    const commandList = Object
        .values(handler.commands)
        .map(command => ({
            name: command.name,
            id: command.id,
            type: "custom" as const,
            default: command.default,
            value: command.hotkey,
            data: command,
            component: undefined,
        }));

    const commandSettingInfo = commandList
        .reduce((acc, command) => {
            acc[command.id] = command;
            return acc;
        }, {} as Record<string, CustomSetting<string>>);


    const commandSettings = settings.createSettings(commandSettingInfo);

    function save() {
        Object.values(commandSettings.value).forEach(s => {
            handler.rebindHotkey(s.id, s.value);
        });

        handler.registerKeybindings();
    }

    return settings.page(
        commandSettings,
        "Commands",
        commandList.map(c => c.id),
        { component: CommandLayout, save, props: { handler } }
    );
}
